import React from "react";
import { useLocation } from "react-router-dom";

const EmbedFooter = () => {
  const location = useLocation();
  const isEmbedMode = location.pathname.includes("/embed");

  if (!isEmbedMode) {
    return null;
  }

  return (
    <footer className="embed-footer">
      <p>
        &copy; {new Date().getFullYear()} VegifyIt |{" "}
        <a
          className="embed-footer-link"
          href="https://www.vegifyit.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          vegifyit.com
        </a>
      </p>
    </footer>
  );
};

export default EmbedFooter;

